<template>
  <div class="part mt-4">
    <div class="header_style justify-content-start">
      <h2 class="h2_style mb-0">GPU</h2>
    </div>

    <div class="part__cnt">
      <div class="d-flex flex-wrap custom-labels mt-3">
        <ul v-for="item in GPUValue" :key="item.label" class="field d-flex ps-0 my-0">
          <li class="field-label">{{ item.label }}</li>
          <li class="field-value">{{ item.value || '-' }}</li>
        </ul>
        <ul v-for="item in gpuNewFieldsData" :key="item.label" class="field d-flex ps-0 my-0">
          <li class="field-label">{{ item.label }}</li>
          <li class="field-value">{{ item.value || '-' }}</li>
        </ul>
      </div>

      <div v-show="hasData(general_counterDataFields)" class="position-relative"> 
        <div
          id="gpu_general_counter"
          style="width: 100%; height: 400px"
        ></div>
        <label-list ref="labelList1" :perf_second_data="perf_second_data" chartKey="gpu_general_counter_chart" />
        <chart-rect ref="chartRect1" chartKey="gpu_general_counter_chart" />
      </div>
      <br />

      <div v-show="hasData(memory_counterDataFields)" style="position: relative">
        <div class="position-relative"> 
          <div
            id="gpu_memory_counter"
            style="width: 100%; height: 400px"
          ></div>
          <label-list ref="labelList2" :perf_second_data="perf_second_data" chartKey="gpu_memory_counter_chart" />
          <chart-rect ref="chartRect2" chartKey="gpu_memory_counter_chart" />
        </div>
      </div>
      <br />

      <div v-show="hasData(shader_counterDataFields)" style="position: relative">
        <div class="position-relative"> 
          <div
            id="gpu_shader_counter"
            style="width: 100%; height: 400px"
          ></div>
          <label-list ref="labelList3" :perf_second_data="perf_second_data" chartKey="gpu_shader_counter_chart" />
          <chart-rect ref="chartRect3" chartKey="gpu_shader_counter_chart" />
        </div>
      </div>
      <br />

      <template v-if="project_id == 59 && testInfo0?.device_type == 1">
        <div v-show="gpuRows?.Device?.length" class="position-relative">
          <div class="position-relative">
            <div id="gpu_device" style="width: 100%; height: 400px"></div>
            <label-list ref="labelList4" :perf_second_data="perf_second_data" chartKey="gpu_device_chart" />
            <chart-rect ref="chartRect4" chartKey="gpu_device_chart" />
          </div>
        </div>

        <div v-show="gpuRows?.Render?.length" class="position-relative">
          <div class="position-relative"> 
            <div id="gpu_render" style="width: 100%; height: 400px"></div>
            <label-list ref="labelList5" :perf_second_data="perf_second_data" chartKey="gpu_render_chart" />
            <chart-rect ref="chartRect5" chartKey="gpu_render_chart" />
          </div>
        </div>

        <div v-show="gpuRows?.Tiler?.length" class="position-relative">
          <div class="position-relative"> 
            <div id="gpu_tiler" style="width: 100%; height: 400px"></div>
            <label-list ref="labelList6" :perf_second_data="perf_second_data" chartKey="gpu_tiler_chart" />
            <chart-rect ref="chartRect6" chartKey="gpu_tiler_chart" />
          </div>
        </div>
      </template>
      <div v-else class="position-relative">
        <div v-show="hasData(['GUsage[%]'])" class="position-relative">
          <div
            id="gpu_gusage"
            style="width: 100%; height: 400px"></div>
          <label-list ref="labelList7" :perf_second_data="perf_second_data" chartKey="gpu_gusage_chart" />
          <chart-rect ref="chartRect7" chartKey="gpu_gusage_chart" />
        </div>
      </div>

      <template v-for="field of fullDataFields" :key="field">
        <div v-show="hasFullData(field)" class="position-relative mt-5">
          <div :id="`gpu_full_${field}`" style="width: 100%; height: 400px"></div>
          <label-list :ref="`labelList-${field}`" :perf_second_data="perf_second_data" :chartKey="`gpu_full_${field}_chart`" />
          <chart-rect :ref="`chartRect-${field}`" :chartKey="`gpu_full_${field}_chart`" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import LabelList from '../label-list.vue'
import {allChart} from '../common.js'
import ChartRect from '../rect.vue'

const useGeneral_counter = {
  data() {
    return {
      general_counterSeries: [
        {name: 'GpuBusBusy', dataKey: 'GpuBusBusy[%]'},
        {name: 'ShadersBusy', dataKey: 'ShadersBusy[%]'},
        {name: 'PreClippedPolygons', dataKey: 'PreClippedPolygons[K]'},
      ]
    }
  },

  computed: {
    general_counterDataFields() {
      return this.general_counterSeries.map(item => item.dataKey)
    }
  },

  methods: {
    getGeneral_counterOption() {
      return {
        title: {
          text: "GPU General Counter",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xData,
        },
        series: this.general_counterSeries.map(item => {
          return {
            name: item.name,
            type: "line",
            showSymbol: false,
            data: this.secondData?.[item.dataKey],
            itemStyle: this.chartSettings.itemStyle2,
          }
        }),
      }
    },

    drawPieChartGPUGeneralCounter() {
      let chartDom = document.getElementById("gpu_general_counter")
      if (!chartDom) return
      if (!allChart.gpu_general_counter_chart) {
        allChart.gpu_general_counter_chart = echarts.init(chartDom)
      }
      allChart.gpu_general_counter_chart.setOption(this.getGeneral_counterOption(), {notMerge: true})
    },
  }
}

const useMemory_counter = {
  data() {
    return {
      memory_counteSeries: [
        {name: 'ReadTotal', dataKey: 'ReadTotal[MB]'},
        {name: 'WriteTotal', dataKey: 'WriteTotal[MB]'},
        {name: 'TextureL2Miss', dataKey: 'TextureL2Miss[%]'},
        {name: 'StalledOnSystemMemory', dataKey: 'StalledOnSystemMemory[%]'},
      ]
    }
  },

  computed: {
    memory_counterDataFields() {
      return this.memory_counteSeries.map(item => item.dataKey)
    }
  },

  methods: {
    getMemory_counterOption() {
      return {
        title: {
          text: "GPU Memory Counter",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        timeline: this.chartSettings.timeline,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xData,
        },
        series: this.memory_counteSeries.map(item => {
          return {
            name: item.name,
            type: "line",
            showSymbol: false,
            data: this.secondData?.[item.dataKey],
            itemStyle: this.chartSettings.itemStyle2,
          }
        }),
      }
    },

    drawPieChartGPUMemoryCounter() {
      let chartDom = document.getElementById("gpu_memory_counter")
      if (!chartDom) return
      if (!allChart.gpu_memory_counter_chart) {
        allChart.gpu_memory_counter_chart = echarts.init(chartDom)
      }
      allChart.gpu_memory_counter_chart.setOption(this.getMemory_counterOption(), {notMerge: true})
    },
  }
}

const useShader_counter = {
  data() {
    return {
      shader_counterSeries: [
        {name: 'VerticesShaded[K]', dataKey: 'VerticesShaded[K]'},
        {name: 'FragmentsShaded', dataKey: 'FragmentsShaded[K]'},
      ]
    }
  },

  computed: {
    shader_counterDataFields() {
      return this.shader_counterSeries.map(item => item.dataKey)
    }
  },

  methods: {
    getGpu_shader_counterOption() {
      const series = this.shader_counterSeries.map(item => {
        return {
          name: item.name,
          type: "line",
          showSymbol: false,
          data: this.secondData?.[item.dataKey],
          itemStyle: this.chartSettings.itemStyle2,
        }
      })

      return {
        title: {
          text: "GPU Shader Counter",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xData,
        },
        series,
      }
    },

    drawPieChartGPUShaderCounter() {
      let chartDom = document.getElementById("gpu_shader_counter")
      if (!chartDom) return
      if (!allChart.gpu_shader_counter_chart) {
        allChart.gpu_shader_counter_chart = echarts.init(chartDom)
      }
      allChart.gpu_shader_counter_chart.setOption(this.getGpu_shader_counterOption(), {notMerge: true})
    },
  }
}

const useGpuChart = {
  data() {
    return {
    }
  },

  computed: {
  },

  methods: {
    getSmgChartOption(titleText) {
      return {
        title: {
          text: titleText,
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.gpuRows?.timeline,
        },
        series: [
          {
            name: titleText,
            data: this.gpuRows?.[titleText],
            type: "line",
            showSymbol: false,
            itemStyle: this.chartSettings.itemStyle2,
          }
        ],
      }
    },

    drawSmgGpuChart(domId, titleText) {
      let chartDom = document.getElementById(domId)
      if (!chartDom) return
      if (!allChart[`${domId}_chart`]) {
        allChart[`${domId}_chart`] = echarts.init(chartDom)
      }
      allChart[`${domId}_chart`].setOption(this.getSmgChartOption(titleText), {notMerge: true})
    },

    drawSmgGpuCharts() {
      if (this.project_id == 59 && this.testInfo0.device_type == 1) {
        this.drawSmgGpuChart('gpu_device', 'Device')
        this.drawSmgGpuChart('gpu_render', 'Render')
        this.drawSmgGpuChart('gpu_tiler', 'Tiler')
      }
    }
  }
}

const useGpuUsage = {
  methods: {
    getGpuUsageOption() {
      return {
        title: {
          text: 'GpuUsage[%]',
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xData,
        },
        series: [
          {
            name: 'GUsage[%]',
            type: "line",
            showSymbol: false,
            data: this.secondData?.['GUsage[%]'],
            itemStyle: this.chartSettings.itemStyle2,
          }
        ],
      }
    },

    drawGpuUsage() {
      if (this.project_id != 59 || this.testInfo0.device_type != 1) {
        const domId = 'gpu_gusage'
        let chartDom = document.getElementById(domId)
        if (!chartDom) return
        if (!allChart[`${domId}_chart`]) {
          allChart[`${domId}_chart`] = echarts.init(chartDom)
        }
        allChart[`${domId}_chart`].setOption(this.getGpuUsageOption(), {notMerge: true})
      }
    }
  }
}

const useFullChart = {
  computed: {
    fullData() {
      return this.perf_second_data?.['GPU完整数据'] || {}
    },

    fullDataFields() {
      return Object.keys(this.fullData)
    }
  },

  methods: {
    getFullChartOption(field) {
      const data = this.fullData?.[field] || {},
        rowKeys = Object.keys(data.rows).filter(item => item != 'timeline')

      return {
        title: {
          text: field,
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: this.chartSettings.tooltip,
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: {
          ...this.chartSettings.yAxis,
          axisLabel: {
            formatter: function(value) {
              // 转换为 K、M 等单位
              if (value >= 1000000000000) {
                return Math.round(value / 1000000000000) + 'T'; //万亿
              } else if (value >= 1000000000) {
                return Math.round(value / 1000000000) + 'B'; //十亿
              } else if (value >= 1000000) {
                return Math.round(value / 1000000) + 'M'; //百万
              } else if (value >= 1000) {
                return Math.round(value / 1000) + 'K'; //千
              }
              return value;
            },
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xData,
        },
        series: rowKeys.map(key => {
          return {
            name: key,
            type: "line",
            showSymbol: false,
            data: data.rows[key],
            itemStyle: this.chartSettings.itemStyle2,
          }
        })
      }
    },

    drawFullCharts() {
      this.fullDataFields.forEach(field => {
        const domId = `gpu_full_${field}`
        let chartDom = document.getElementById(domId)
        if (!chartDom) return
        if (!allChart[`${domId}_chart`]) {
          allChart[`${domId}_chart`] = echarts.init(chartDom)
        }
        allChart[`${domId}_chart`].setOption(this.getFullChartOption(field), {notMerge: true})
      })
    },

    hasFullData(field) {
      let result = false
      const data = this.fullData?.[field] || {},
        rowKeys = Object.keys(data.rows).filter(item => item != 'timeline')

      if (this.xData?.length) {
        for (let key of rowKeys) {
          if (data.rows[key]?.filter(item => item || item === 0)?.length) {
            result = true
            break
          }
        }
      }

      return result
    },
  },
}

export default {
  mixins: [useGeneral_counter, useMemory_counter, useShader_counter, useGpuChart, useGpuUsage, useFullChart],

  inject: ['injectObj', 'hasData'],

  props: {
    testInfo3: Object,
    testInfo: Object,
    gpuNewFieldsData: Array,
    testInfo0: Object,
    perf_second_data: Object,
    chartSettings: Object,
  },

  data() {
    return {
    }
  },

  components: {LabelList, ChartRect},

  computed: {
    isAllChecked() {
      return this.injectObj.isAllChecked
    },

    project_id() {
      return this.$route.query.project
    },

    GPUValue() {
      let data = this.testInfo3

      let result = [
        {
          label: "GpuBusBusy[%]",
          value: data?.gpu_bus_busy,
        },
        {
          label: "ShadersBusy[%]",
          value: data?.shaders_busy,
        },
        {
          label: "PreClippedPolygons[K]",
          value: data?.pre_clipped_polygons,
        },
        {
          label: "ReadTotal[MB]",
          value: data?.read_total,
        },
        {
          label: "WriteTotal[MB]",
          value: data?.write_total,
        },
        {
          label: "TextureL2Miss[%]",
          value: data?.texturel2miss,
        },
        {
          label: "StalledOnSystemMemory[%]",
          value: data?.stalled_on_system_memory,
        },
        {
          label: "VerticesShaded[K]",
          value: data?.vertices_shaded,
        },
        {
          label: "FragmentsShaded[K]",
          value: data?.fragments_shaded,
        },
        {
          label: "GUsage[%]",
          value: data?.gpu_usage,
        },
        {
          label: "GClock[MHz]",
          value: data?.custom_data?.GClock,
        },
      ]

      if (this.testInfo0?.device_type == 1) {
        result = [
          {
            label: "Device",
            value: data?.Device,
          },
          {
            label: "Render",
            value: data?.Render,
          },
          {
            label: "Tiler",
            value: data?.Tiler,
          },
          ...result
        ]
      }

      return result
    },

    secondData() {
      return this.perf_second_data?.['每秒数据']?.rows || {}
    },

    xData() {
      return this.secondData?.timeline || []
    },

    gpuRows() {
      return this.perf_second_data?.['GPU']?.rows || {}
    },
  },

  methods: {
    isEmpty(arr = []) {
      let empty = true
      
      for (let item of arr) {
        if (item || item === 0) {
          empty = false
          break
        }
      }
      return empty
    },

    drawCharts() {
      this.drawPieChartGPUGeneralCounter()
      this.drawPieChartGPUMemoryCounter()
      this.drawPieChartGPUShaderCounter()
      this.drawSmgGpuCharts()
      this.drawGpuUsage()
      this.drawFullCharts()
    },

    async init(isMounted) {
      this.drawCharts()
      await this.$nextTick()
      this.$refs.chartRect1?.init(isMounted)
      this.$refs.chartRect2?.init(isMounted)
      this.$refs.chartRect3?.init(isMounted)
      this.$refs.chartRect4?.init(isMounted)
      this.$refs.chartRect5?.init(isMounted)
      this.$refs.chartRect6?.init(isMounted)
      this.$refs.chartRect7?.init(isMounted)

      this.fullDataFields.forEach(field => {
        this.$refs[`chartRect-${field}`]?.init(isMounted)
      })
    }
  }
}
</script>

<style scoped>
@import "../common.css"
</style>